
const digest = 'af2ee0ef53553bfadfff3724a739b9c3ce5ef217ebcc8abbeb07beacfc4d22b1';
const classes = {"wrapper":"_wrapper_r58z8_1","backdrop":"_backdrop_r58z8_16","showChat":"_showChat_r58z8_25","sm":"_sm_r58z8_34","md":"_md_r58z8_39","lg":"_lg_r58z8_45","xl":"_xl_r58z8_50","modal":"_modal_r58z8_55","fullScreen":"_fullScreen_r58z8_74","fullScreenScroll":"_fullScreenScroll_r58z8_79","header":"_header_r58z8_84","headerTitle":"_headerTitle_r58z8_93","close":"_close_r58z8_105","content":"_content_r58z8_113","maxHeight":"_maxHeight_r58z8_118","contentScroll":"_contentScroll_r58z8_122","noPadding":"_noPadding_r58z8_126"};
const css = `._wrapper_r58z8_1 {
  position: fixed;
  z-index: 1050;
  background: rgba(6, 42, 96, 0.9);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100vw;
  max-height: 100vh;
}

._backdrop_r58z8_16 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
}

._showChat_r58z8_25 {
  max-width: calc(100vw - 440px);
  width: 100%;
  height: 100%;
  border-radius: 0 20px 20px 0;
  box-shadow: 0 0 12px 6px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

._sm_r58z8_34 {
  width: 300px !important;
  max-width: 300px !important;
}

._md_r58z8_39 {
  width: 500px !important;
  max-width: 500px !important;
  min-width: 500px !important;
}

._lg_r58z8_45 {
  width: 800px !important;
  max-width: 800px !important;
}

._xl_r58z8_50 {
  width: 1140px !important;
  max-width: 1140px !important;
}

._modal_r58z8_55 {
  background: #ffffff;
  width: fit-content;
  -webkit-box-shadow: 0px 0px 41px 9px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 41px 9px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 41px 9px rgba(0, 0, 0, 0.2);
  min-width: 600px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  max-width: calc(100vw - 30px);
  max-height: calc(100vh - 30px);
}

@media (max-width: 600px) {
  ._modal_r58z8_55 {
    min-width: 100%;
  }
}
._fullScreen_r58z8_74 {
  width: calc(100vw - 40px);
  height: calc(100vh - 40px);
}

._fullScreenScroll_r58z8_79 {
  overflow-y: scroll;
  height: 100%;
}

._header_r58z8_84 {
  padding: 34px 24px;
  border-bottom: 1px solid #eaedf3;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

._headerTitle_r58z8_93 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: Rubik, sans-serif;
  color: #000000;
  font-weight: 500;
  font-size: 18px;
  padding-right: 25px;
}

._close_r58z8_105 {
  font-family: Rubik, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #d81616;
  cursor: pointer;
}

._content_r58z8_113 {
  padding: 34px 24px;
  overflow-y: auto;
}

._maxHeight_r58z8_118 {
  height: calc(100vh - 180px);
}

._contentScroll_r58z8_122 {
  overflow-y: scroll;
}

._noPadding_r58z8_126 {
  padding: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  